module.exports = __webpack_public_path__ + "static/media/pexels-rodolfo-clix-1036936.080a2378.jpg";